import { getAllSnapshotsNames } from "../s3/GetSnapshotsNames";
import { deleteSnapshot } from "../s3/DeleteSnapshot";

/* 
  Submits a completed CSV to S3 
  with the status Requested
*/

export async function SaveRepXRequestCSV(S3, initialFileName, csvData) {
  // S3 bucket and fileName initialisation
  const bucket = process.env.REACT_APP_S3_BUCKET;
  let fileName = initialFileName;
  console.log(fileName)

    // Upload CSV to S3 to override the previous version
    const csvKey =
      localStorage.getItem("s3Link") + "/Forms/Snapshots/" + fileName + ".csv";
    try {
      const uploadResponse = await S3.upload({
        Bucket: bucket,
        Key: csvKey,
        Body: csvData,
        // Difference is Status Tag being Submitted
        Tagging: `status=Requested&uploadedBy=${localStorage.getItem(
          "email"
        )}`,
      }).promise();

      // Console Testing
      console.log("Snapshot uploaded successfully:", uploadResponse);
    } catch (error) {
      console.error("Error saving snapshot for later:", error);
      throw new Error("UploadError");
    }
  
}